export default __webpack_public_path__ + "static/media/Kalam-Light.26d8dba0.ttf";